const styles = () => ({
  tabsRoot: {
  },
  tabRoot: {
    color: "#75caed",
    opacity: 1,
    borderBottom: "none",
    textTransform: "capitalize",
    minWidth: 100
  },
  hiddenTab: {
    display: "none"
  },
  tabSelected: {
    fontWeight: "bold",
    opacity: 1,
    color: "#34aae1",
    borderBottom: "none"
  },
  tabsIndicator: {
    backgroundColor: "#1890ff"
  },
  badge: {
    backgroundColor: "#2196f3",
    color: "#fff",
    fontWeight: "bold"
  }
});
export default styles;
